export default "__VITE_ASSET__BoCs8pB9__"